define(
    [
        'jquery',
        'assets/js/modules/popup/Popup',
        'assets/js/modules/utils',
        'assets/js/common/router/index',
        'assets/js/modules/ActionInProgressOverlay',
        'jquery.fileupload',
        'jquery.fileupload-image',
        'jquery.fileupload-validate',
        'jquery.validate'
    ],
    function($, Popup, utils, router, ActionInProgressOverlay) {
        return {
            MAX_ATTACHED_FILES: 10,
            MAX_FILE_SIZE: 8000000,
            ANIMATION_SPEED: 200,
            TAB_CLASS_ACTIVE: 'active',
            STEP_CLASS_ACTIVE: 'active',
            API_CONTACT_INFO: '/submit-contact-info',
            API_DROP_FILE: '/remove-uploaded-file',

            hasCaptcha: false,
            $collapseTitle: $('.contact-us-collapse-title'),
            $collapseContent: $('.contact-us-collapse-content'),

            $step: $('.contact-us-step'),
            $info: $('.contact-us-collapse-info'),
            $radio: null,

            $form: $('.contact-form'),
            $formType: $('#contact_us_type'),
            $formTypeId: $('#contact_us_typeId'),
            $formSubmit: $('#contactus_submit'),
            $formQuestion: $('#contact_us_question'),
            $formQuestionId: $('#contact_us_questionId'),
            $formDepartment: $('#contact_us_department'),
            $formInvoice: $('#invoice'),
            $formInvoiceField: $('.js-contact-invoice-field'),
            $status: $('.contact-us-status'),

            $fileUploadBlock: $('.contact-form-file-upload'),
            $fileUploadInput: $('#fileupload'),
            $fileUploadLabel: $('.js-contact-files-label'),
            $fileUploadButton: $('.fileinput-button'),
            $filesPreviewBlock: $('.contact-form-files'),
            $filesErrorBlock: $('.contact-form-file-error'),
            fileThumbClass: 'contact-form-file-thumb',

            $accountButton: $('.account-contact-us-show'),
            $accountBlock: $('.account-contact-us'),

            $popupAttachFilesElement: $('.popup-attach-files'),
            $captchaWarn: $('.captcha-warn'),

            $popupCancel: $('.popup-cancel'),
            popupThankYou: null,
            popupGoToOrders: null,
            popupAttachFiles: null,
            progressOverlay: null,
            validator: null,
            defectiveProductDepartment: 'defective_product',
            invoiceRequiredQuestionIds: {
                'existing-order-status': true,
                'existing-order-change-design': true,
                'existing-order-update-products': true,
                'existing-order-cancel-order': true,
                'existing-order-bad-order': true,
                'existing-order-defective-product': true,
                'existing-order-damaged-order': true,
                'existing-order-not-full-order': true,
                'existing-order-mine-order': true,
                'existing-order-other': true,
                'new-order-discount': true,
                'file-help-bad-queue': true,
                'shipping-expedite': true,
                'billing-invoice': true
            },

            init: function(showPopup) {
                var _this = this;
                this.$radio = this.$collapseContent.find('input');
                this.$popupAttachFilesCancel = this.$popupAttachFilesElement.find('.btn-cancel');
                this.$popupAttachFilesContinue = this.$popupAttachFilesElement.find('.btn-continue');
                this.progressOverlay = new ActionInProgressOverlay({ el: '.contact-us' });
                this.hasCaptcha = this.$form.find('.contact-form-captcha').length > 0;
                this.defectiveProductDepartment = $.trim(
                    this.$form.data('department-defective-product') || this.defectiveProductDepartment
                );

                if (ONP.user.loggedIn) {
                    this.hideUserInputs();
                }

                this.popupThankYou = new Popup($('#popup-thank-you'), {
                    width: 300,
                    minHeight: 170
                });

                this.popupGoToOrders = new Popup($('#popup-contact-us-orders'), {
                    width: 580,
                    minHeight: 150
                });

                this.popupAttachFiles = new Popup(this.$popupAttachFilesElement, {
                    width: 500,
                    minHeight: 150
                });

                this.$popupAttachFilesCancel.on('click', function(e) {
                    e.preventDefault();
                    _this.popupAttachFiles.close();
                });

                this.$popupAttachFilesContinue.on('click', function(e) {
                    e.preventDefault();
                    _this.popupAttachFiles.close();
                    _this.submitForm();
                });

                this.$popupCancel.on('click', function(e) {
                    e.preventDefault();
                    _this.popupGoToOrders.close();
                    _this.popupThankYou.close();
                });

                if (showPopup) {
                    if (ONP.user.loggedIn) {
                        this.popupGoToOrders.open();
                    }
                }

                this.$accountButton.on('click', function(e) {
                    e.preventDefault();
                    $(this).hide();
                    _this.$accountBlock.show();
                    _this.scrollTo($('.contact-us'));
                });

                this.$collapseTitle.on('click', function() {
                    _this.clearFormStatus();
                    if (_this.isTabOpened($(this))) {
                        return _this.closeTab($(this));
                    }

                    return _this.openTab($(this));
                });

                this.$radio.on('change', function() {
                    _this.changeRadioInput($(this));
                });

                // Radio button can be checked when user clicks `back` in browser
                var $checkedRadioInput = this.$radio.filter(':checked');
                if ($checkedRadioInput.length === 1) {
                    this.changeRadioInput($checkedRadioInput);
                }

                this.$step.on('click', function() {
                    var currentStepIndex = $(this).data('step');
                    _this.clearFormStatus();

                    if (currentStepIndex == 2 && _this.allTabsClosed()) {
                        _this.openTab(_this.$collapseTitle.first());
                    }
                });

                this.$formSubmit.on('click', function(e) {
                    e.preventDefault();
                    _this.$captchaWarn.hide();
                    _this.clearFormStatus();
                    _this.clearFileValidationError();
                    _this.syncSelectedQuestionFields();

                    if (_this.applyInvoiceRequiredErrorIfMissing()) {
                        return;
                    }

                    if (_this.applyRequiredFileErrorIfMissing()) {
                        return;
                    }

                    if (!_this.$form.valid()) {
                        return;
                    }

                    if (_this.showFileAttachPopup() && !_this.hasAttachedFiles()) {
                        _this.popupAttachFiles.open();
                    } else {
                        _this.submitForm();
                    }
                });

                this.$filesPreviewBlock.on('click', '.remove', function(e) {
                    e.preventDefault();
                    if (confirm(this.$form.data('message-confirmFileRemove'))) {
                        _this.removeFile($(this));
                    }
                });

                this.initFileUpload().initFormValidation();
            },

            /**
             * Returns true if checked radio button's id is
             * one of those ids below
             *
             * @return {boolean}
             */
            showFileAttachPopup: function() {
                if (this.isFileRequiredForCurrentSelection()) {
                    return false;
                }

                // Array of radio button ids
                return (
                    ['existing-order-defective-product', 'existing-order-damaged-order', 'existing-order-mine-order'].indexOf(
                        this.$collapseContent.find('input[type=radio]:checked').attr('id')
                    ) !== -1
                );
            },

            /**
             * @return {boolean}
             */
            hasAttachedFiles: function() {
                return this.$filesPreviewBlock.find('.remove').length > 0;
            },

            submitForm: function() {
                var _this = this;

                this.$formSubmit.attr('disabled', 'disabled');
                this.progressOverlay.show();
                this.clearFileValidationError();

                var formData = this.$form.serializeArray();
                $.ajax({
                    url: router.generate(_this.API_CONTACT_INFO),
                    type: 'POST',
                    data: formData
                })
                    .done(function(data, textStatus, request) {
                        _this.submitCallback(request);
                    })
                    .fail(function(request) {
                        _this.submitCallback(request);
                    })
                    .always(function() {
                        _this.progressOverlay.hide();
                    });
            },

            /**
             * @param {jQuery} $targetRadioInput
             */
            changeRadioInput: function($targetRadioInput) {
                this.$radio.not($targetRadioInput).prop('checked', false);
                this.$radio
                    .parent()
                    .find(this.$info)
                    .slideUp(this.ANIMATION_SPEED);
                this.showForm($targetRadioInput);
                this.syncSelectedQuestionFields($targetRadioInput);
                this.$formDepartment.val($targetRadioInput.attr('data-department-id') || '');
                this.validator.resetForm();
                this.clearFormStatus();
                this.clearFileValidationError();

                var $currentTab = $targetRadioInput.closest(this.$collapseContent).prev(this.$collapseTitle);
                if (!this.isTabOpened($currentTab)) {
                    this.openTab($currentTab);
                }
            },

            /**
             * @returns {contactUsPage}
             */
            initFormValidation: function() {
                var _this = this;
                this.validator = this.$form.validate({
                    ignore: '',
                    rules: {
                        'contact_us[firstName]': { required: true },
                        'contact_us[lastName]': { required: true },
                        'contact_us[email]': { required: true, email: true },
                        'contact_us[comments]': { required: true },
                        'contact_us[invoice]': {
                            required: {
                                depends: function() {
                                    return _this.isInvoiceRequiredForCurrentSelection();
                                }
                            },
                            digits: {
                                depends: function() {
                                    return $.trim(_this.$formInvoice.val() || '') !== '';
                                }
                            }
                        }
                    },
                    messages: {
                        'contact_us[firstName]': this.$form.data('error-message-firstName'),
                        'contact_us[lastName]': this.$form.data('error-message-lastName'),
                        'contact_us[email]': this.$form.data('error-message-email'),
                        'contact_us[comments]': this.$form.data('error-message-comments'),
                        'contact_us[invoice]': {
                            required: this.$form.data('error-message-invoice'),
                            digits: this.$form.data('error-message-invoice-format')
                        }
                    },
                    errorPlacement: function(error, element) {
                        error.appendTo(element.parent());
                    },
                    debug: true
                });

                return this;
            },

            /**
             * @returns {contactUsPage}
             */
            initFileUpload: function() {
                var _this = this;

                this.$fileUploadInput
                    .fileupload({
                        dataType: 'json',
                        autoUpload: true,
                        acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
                        // Enable image resizing, except for Android and Opera,
                        // which actually support image resizing, but fail to
                        // send Blob objects via XHR requests:
                        disableImageResize: /Android(?!.*Chrome)|Opera/.test(window.navigator.userAgent),
                        previewMaxWidth: 100,
                        previewMaxHeight: 100,
                        previewCrop: true,
                        maxNumberOfFiles: _this.MAX_ATTACHED_FILES
                    })
                    .on('fileuploadadd', function(e, data) {
                        _this.$filesErrorBlock.text('');
                        var files = _this.$filesPreviewBlock.children();

                        if (files.length + 1 > _this.MAX_ATTACHED_FILES) {
                            var message = _this.$form.data('message-max-files');
                            _this.$filesErrorBlock.text(message);

                            return false;
                        }

                        var hasError = false;
                        data.originalFiles.forEach(function(value) {
                            if (value['size'] > _this.MAX_FILE_SIZE) {
                                hasError = true;
                            }
                        });

                        if (hasError) {
                            _this.$filesErrorBlock.text(_this.$form.data('message-upload-size'));

                            return false;
                        }

                        data.context = $('<div/>')
                            .addClass(_this.fileThumbClass)
                            .appendTo(_this.$filesPreviewBlock);
                        $.each(data.files, function(index, file) {
                            var fileHash = utils.getStringHash(file.name);
                            data.context
                                .append($('<span/>').text(file.name))
                                .append(
                                    '<div id="progress' +
                                        fileHash +
                                        '" class="contact-form-file-progress">' +
                                        '<div class="progress-bar"></div>' +
                                        '</div>'
                                );
                        });
                    })
                    .on('fileuploadprocessalways', function(e, data) {
                        var index = data.index;
                        var file = data.files[index];
                        if (data.context) {
                            var node = $(data.context[index]);
                            if (file.preview) {
                                node.prepend(file.preview);
                            }
                            if (file.error) {
                                node.addClass('error').append(file.error);
                            }
                        } else {
                            return false;
                        }
                    })
                    .on('fileuploadprogress', function(e, data) {
                        var progress = parseInt(data.loaded / data.total * 100, 10);
                        $.each(data.files, function(index, file) {
                            $('#progress' + utils.getStringHash(file.name) + ' .progress-bar').css('width', progress + '%');
                        });
                    })
                    .on('fileuploaddone', function(e, data) {
                        $.each(data.files, function(index, file) {
                            var message = _this.$form.data('message-files-complete');
                            $('#progress' + utils.getStringHash(file.name) + ' .progress-bar').text(message);
                            var $removeIcon = $(
                                '<div class="remove ui-icon ui-icon-close" data-file="' + data.result.filename + '"></div>'
                            );
                            data.context.append($removeIcon);
                            _this.clearFileValidationError();
                        });
                    })
                    .on('fileuploadfail', function(e, data) {
                        $.each(data.files, function(index, file) {
                            var message = _this.$form.data('message-files-error');
                            $('#progress' + utils.getStringHash(file.name) + ' .progress-bar')
                                .css('background-color', 'red')
                                .text(message);
                        });
                    });

                return this;
            },
            /**
             * @param {jqXHR} request
             * @returns {boolean}
             */
            submitCallback: function(request) {
                this.$formSubmit.removeAttr('disabled');
                var isSuccess = request.status >= 200
                    && request.status < 300
                    && $.trim(request.responseText) === 'true';

                if (!isSuccess) {
                    if (this.applyInvoiceRequiredErrorIfMissing()) {
                        return false;
                    }

                    if (this.applyInvoiceFormatErrorIfInvalid()) {
                        return false;
                    }

                    if (this.applyInvoiceOwnershipErrorIfInvalid(request)) {
                        return false;
                    }

                    if (this.applyRequiredFileErrorIfMissing()) {
                        return false;
                    }

                    if (this.hasCaptcha) {
                        this.$captchaWarn.show();
                        return false;
                    }

                    this.showFormStatus('error', this.$status.data('message-submit-error'));

                    return false;
                }

                this.highlightStep(3);

                var _this = this;
                this.resetForm(function() {
                    _this.showFormStatus('success', _this.$status.data('message-submit-success'));
                    _this.popupThankYou.open();
                });

                if (this.hasCaptcha && typeof grecaptcha !== 'undefined') {
                    grecaptcha.reset();
                }
            },

            resetForm: function(onScrollComplete) {
                this.collapse();
                this.$form[0].reset();
                this.$filesPreviewBlock.html('');
                this.clearFileValidationError();
                this.toggleInvoiceRequirement(false);
                this.toggleFileRequirement(false);
                this.$formQuestionId.val('');
                this.$formQuestion.val('');
                this.$captchaWarn.hide();
                this.validator.resetForm();

                var _this = this;
                this.scrollTo($('.contact-us'), function() {
                    if ($.isFunction(onScrollComplete)) {
                        onScrollComplete();
                    }
                });
            },

            /**
             * @param {jQuery} $el
             * @param callback
             */
            scrollTo: function($el, callback) {
                $('html, body').animate(
                    {
                        scrollTop: $el.offset().top
                    },
                    this.ANIMATION_SPEED,
                    'swing',
                    callback
                );
            },

            hideUserInputs: function() {
                $('.contact-form-column.right').removeClass('right');
                $('#firstName, #lastName, #email')
                    .parent()
                    .hide();
            },

            /**
             * @param {jQuery} $radio
             */
            showForm: function($radio) {
                if ($radio.hasClass('has-upload')) {
                    this.$fileUploadBlock.removeClass('hidden');
                } else {
                    this.$fileUploadBlock.addClass('hidden');
                }

                $radio
                    .parent()
                    .find('.contact-us-collapse-info')
                    .append(this.$form.show())
                    .slideDown(this.ANIMATION_SPEED);
            },

            /**
             * @param {number} stepIndex
             */
            highlightStep: function(stepIndex) {
                this.$step.removeClass(this.STEP_CLASS_ACTIVE);
                this.getStepElementByIndex(stepIndex).addClass(this.STEP_CLASS_ACTIVE);
            },

            /**
             * @param {number} stepIndex
             * @return {jQuery}
             */
            getStepElementByIndex: function(stepIndex) {
                return $('#contact-step-' + stepIndex);
            },

            /**
             * @param {jQuery} $tab
             */
            closeTab: function($tab) {
                $tab
                    .removeClass(this.TAB_CLASS_ACTIVE)
                    .next()
                    .slideUp(this.ANIMATION_SPEED);
                this.validator.resetForm();
                this.clearFormStatus();
                this.clearFileValidationError();

                if (this.allTabsClosed()) {
                    this.highlightStep(1);
                }
            },

            /**
             * @param {jQuery} $tab
             */
            openTab: function($tab) {
                this.collapse();
                $tab
                    .addClass(this.TAB_CLASS_ACTIVE)
                    .next()
                    .slideDown(this.ANIMATION_SPEED);
                this.highlightStep(2);
                this.$formType.val($tab.text());
                this.$formTypeId.val($tab.attr('id'));
                this.clearFormStatus();
                this.clearFileValidationError();
            },

            /**
             * @param {jQuery} $tab
             * @return {boolean}
             */
            isTabOpened: function($tab) {
                return $tab.hasClass(this.TAB_CLASS_ACTIVE);
            },

            /**
             * @return {boolean}
             */
            allTabsClosed: function() {
                var _this = this;
                var allTabsClosed = true;

                this.$collapseTitle.each(function(index, element) {
                    if (_this.isTabOpened($(element))) {
                        allTabsClosed = false;

                        return false;
                    }
                });

                return allTabsClosed;
            },

            /**
             * Collapse all tabs
             */
            collapse: function() {
                var _this = this;

                this.$collapseTitle.each(function() {
                    $(this).removeClass(_this.TAB_CLASS_ACTIVE);
                });
                this.$collapseContent.slideUp(this.ANIMATION_SPEED);
            },

            /**
             * @param {jQuery} $item
             */
            removeFile: function($item) {
                $item.parent().fadeOut(this.ANIMATION_SPEED, function() {
                    $item.remove();
                });

                $.ajax({
                    method: 'POST',
                    data: { filename: $item.data('file') },
                    url: router.generate(this.API_DROP_FILE)
                });
            },

            /**
             * @param {string|null|undefined} questionId
             * @returns {boolean}
             */
            isInvoiceRequiredQuestion: function(questionId) {
                return !!this.invoiceRequiredQuestionIds[questionId];
            },

            /**
             * @returns {string}
             */
            getSelectedQuestionId: function() {
                var selected = this.$collapseContent.find('input[type=radio]:checked').first();

                return selected.length ? selected.attr('id') || '' : '';
            },

            /**
             * @returns {string}
             */
            getCurrentQuestionId: function() {
                var selectedQuestionId = $.trim(this.getSelectedQuestionId());
                if (selectedQuestionId !== '') {
                    return selectedQuestionId;
                }

                return $.trim(this.$formQuestionId.val() || '');
            },

            /**
             * @returns {string}
             */
            getCurrentDepartment: function() {
                var department = $.trim(this.$formDepartment.val() || '');
                if (department !== '') {
                    return department;
                }

                var selected = this.$collapseContent.find('input[type=radio]:checked').first();
                if (selected.length) {
                    return $.trim(selected.attr('data-department-id') || '');
                }

                return '';
            },

            /**
             * @returns {boolean}
             */
            isInvoiceRequiredForCurrentSelection: function() {
                var questionId = this.getCurrentQuestionId();
                if (questionId !== '') {
                    return this.isInvoiceRequiredQuestion(questionId);
                }

                // Keep client logic aligned with server fallback:
                // existing-order requires invoice when question id is missing.
                return $.trim(this.$formTypeId.val() || '') === 'existing-order';
            },

            /**
             * @returns {boolean}
             */
            isFileRequiredForCurrentSelection: function() {
                return this.getCurrentDepartment() === this.defectiveProductDepartment;
            },

            /**
             * @param {jQuery|null|undefined} $targetRadioInput
             */
            syncSelectedQuestionFields: function($targetRadioInput) {
                var $selected = $targetRadioInput && $targetRadioInput.length
                    ? $targetRadioInput
                    : this.$collapseContent.find('input[type=radio]:checked').first();

                var questionId = $selected.length ? $selected.attr('id') : '';
                var questionText = $selected.length
                    ? $selected
                        .parent()
                        .find('.contact-us-question')
                        .text()
                    : '';

                this.$formQuestionId.val(questionId || '');
                this.$formQuestion.val(questionText);
                this.toggleInvoiceRequirement(this.isInvoiceRequiredForCurrentSelection());
                this.toggleFileRequirement(this.isFileRequiredForCurrentSelection());
            },

            /**
             * @param {boolean} required
             */
            toggleInvoiceRequirement: function(required) {
                this.$formInvoice.prop('required', required);
                this.$formInvoice.toggleClass('required', required);
                this.$formInvoiceField.toggleClass('rq', required);

                if (!required && this.validator) {
                    this.validator.element(this.$formInvoice);
                }
            },

            /**
             * @param {boolean} required
             */
            toggleFileRequirement: function(required) {
                this.$fileUploadLabel.toggleClass('required', required);
            },

            /**
             * @returns {boolean}
             */
            applyInvoiceRequiredErrorIfMissing: function() {
                if (!this.isInvoiceRequiredForCurrentSelection()) {
                    return false;
                }

                if ($.trim(this.$formInvoice.val() || '') !== '') {
                    return false;
                }

                var message = this.$form.data('error-message-invoice') || this.$form.data('error-message-required');
                this.toggleInvoiceRequirement(true);
                if (this.validator) {
                    this.validator.showErrors({ 'contact_us[invoice]': message });
                }

                return true;
            },

            /**
             * @returns {boolean}
             */
            applyInvoiceFormatErrorIfInvalid: function() {
                var invoice = $.trim(this.$formInvoice.val() || '');
                if (invoice === '') {
                    return false;
                }

                if (/^\d+$/.test(invoice)) {
                    return false;
                }

                var message = this.$form.data('error-message-invoice-format') || this.$form.data('error-message-invoice');
                this.toggleInvoiceRequirement(true);
                if (this.validator) {
                    this.validator.showErrors({ 'contact_us[invoice]': message });
                }

                return true;
            },

            /**
             * @param {jqXHR} request
             * @returns {boolean}
             */
            applyInvoiceOwnershipErrorIfInvalid: function(request) {
                if (!this.isInvoiceRequiredForCurrentSelection()) {
                    return false;
                }

                if ($.trim(request.responseText || '') !== 'invoice_invalid') {
                    return false;
                }

                var message = this.$form.data('error-message-invoice-format')
                    || this.$form.data('error-message-invoice')
                    || this.$form.data('error-message-required');
                this.toggleInvoiceRequirement(true);
                if (this.validator) {
                    this.validator.showErrors({ 'contact_us[invoice]': message });
                }

                return true;
            },

            /**
             * @returns {boolean}
             */
            applyRequiredFileErrorIfMissing: function() {
                if (!this.isFileRequiredForCurrentSelection()) {
                    return false;
                }

                if (this.hasAttachedFiles()) {
                    return false;
                }

                this.$filesErrorBlock.text(this.$form.data('error-message-files-required'));

                return true;
            },

            clearFileValidationError: function() {
                this.$filesErrorBlock.text('');
            },

            /**
             * @param {string} type
             * @param {string} message
             */
            showFormStatus: function(type, message) {
                if (!this.$status.length || !message) {
                    return;
                }

                this.$status
                    .removeClass('hidden is-success is-error')
                    .addClass(type === 'success' ? 'is-success' : 'is-error')
                    .text(message);
            },

            clearFormStatus: function() {
                if (!this.$status.length) {
                    return;
                }

                this.$status
                    .addClass('hidden')
                    .removeClass('is-success is-error')
                    .text('');
            }
        };
    }
);
